import React from "react";
import { NavLink, useLoaderData } from "react-router-dom";

import Breadcrumbs from "./Breadcrumbs";
import AnswerBadges from "./AnswerBadges";
import ResetAnswersButton from "./ResetAnswersButton";

const CategoriesPage = () => {
  const {categories} = useLoaderData();
  return (
    <div>
      <Breadcrumbs />
      <main>
        <div className="row g-0">
          <div className="col d-grid gap-2">
            <NavLink className="btn btn-outline-primary" to="/quiz">
              Start Quiz
            </NavLink>
          </div>
          <div className="col d-grid gap-2">
            <NavLink className="btn btn-outline-primary" to="/exam">
              Start Exam
            </NavLink>
          </div>
        </div>
        <div className="list-group list-group-flush">
          {categories().map((category) => (
            <div
              key={category}
              className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            >
              <NavLink className="stretched-link text-dark" to={category}>
                {category}
              </NavLink>
              <AnswerBadges category={category} />
            </div>
          ))}
        </div>
        <ResetAnswersButton className="btn btn-outline-danger" />
      </main>
    </div>
  );
};

export default CategoriesPage;
